import React from 'react';
import { Dropdown } from '../Dropdown';
import { Input } from '../Input';
import { FilterRenderFn } from './types';

export const TextField: FilterRenderFn = (displayName, value, handleChange) => (
  <Input
    data-testid="filter-item-text-field"
    name={displayName}
    value={value}
    onChange={(id, newValue: string) => handleChange(newValue)}
  />
);

export const BooleanDropdown: FilterRenderFn = (
  displayName,
  value,
  handleChange
) => (
  <Dropdown
    name={displayName}
    options={[
      { value: 'true', display: 'Yes' },
      { value: 'false', display: 'No' }
    ]}
    value={value}
    onChange={(id, newValue: string) => handleChange(newValue)}
  />
);
